import { render, staticRenderFns } from "./AdvOrderTransportersSingle.vue?vue&type=template&id=2bc9f439&scoped=true"
import script from "./AdvOrderTransportersSingle.vue?vue&type=script&lang=js"
export * from "./AdvOrderTransportersSingle.vue?vue&type=script&lang=js"
import style0 from "./AdvOrderTransportersSingle.vue?vue&type=style&index=0&id=2bc9f439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9f439",
  null
  
)

export default component.exports